export default {
  getTable(state) {
    return state.table;
  }
};
